import { create } from "zustand";
import type { Impersonator, UserPermission, UserRole } from "@/lib/api";

interface UserState {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	role: UserRole;
	/** ロールを考慮した実効権限。 */
	permissions: UserPermission[];
	organizationId: string;
	organizationName: string;
	/** 組織のクレジット残高が枯渇し、利用が制限されているか。 */
	creditExhausted: boolean;
	deviceManagementAvailable: boolean;
	/** ヘルプエージェントを使える環境か (クラウド版のみ)。 */
	helpAgentAvailable: boolean;
	/** 課金情報をクラウド版で管理する環境か。ローカル版では案内だけを表示する。 */
	billingManagedInCloud: boolean;
	/** ロードマップ (/roadmap) を使えるか。クラウド版の自社組織のユーザーだけ。 */
	roadmapAvailable: boolean;
	/** ナレッジグラフのタブを使えるか。クラウド版では許可した組織のユーザーだけ、ローカル版では誰でも。 */
	knowledgeGraphAvailable: boolean;
	/** 成り代わり中のみ非 null。成り代わり元 (SuperAdmin) の情報。 */
	impersonator: Impersonator | null;
	setUser: (user: {
		id: string;
		firstName: string;
		lastName: string;
		email: string;
		role: UserRole;
		permissions: UserPermission[];
		organizationId: string;
		organizationName: string;
		creditExhausted: boolean;
		deviceManagementAvailable: boolean;
		helpAgentAvailable: boolean;
		billingManagedInCloud: boolean;
		roadmapAvailable: boolean;
		knowledgeGraphAvailable: boolean;
		impersonator: Impersonator | null;
	}) => void;
}

export const useCurrentUserStore = create<UserState>((set) => ({
	id: "",
	firstName: "",
	lastName: "",
	email: "",
	role: "Member",
	permissions: [],
	organizationId: "",
	organizationName: "",
	creditExhausted: false,
	impersonator: null,
	deviceManagementAvailable: false,
	helpAgentAvailable: false,
	billingManagedInCloud: false,
	roadmapAvailable: false,
	knowledgeGraphAvailable: false,
	setUser: (user) => set(user),
}));
